import { Demographics } from './Demographics';
import { ParcelAssessment } from './ParcelAssessment';
import { ParcelHrmData } from './ParcelHrmData';
import { BuildingPermit } from './BuildingPermit';
import { CivicAddress } from './CivicAddress';

export interface IParcelData {
    PID: string;
    Communiuty: string;
    Demographics?: Demographics;
    CivicAddress: string; // listing only
    CivicAddresses: CivicAddress[] | null; // parcel only
    ParcelAssessments: ParcelAssessment[];
    ParcelHrmData: ParcelHrmData;
    ChildParcels: any; // ?? TODO pid array ?? need an exmple or is this even used ??
    BuildPermits: BuildingPermit[];
    WalkTimeGeoJson: string;
    IsParent: boolean;
}


export class ParcelData implements IParcelData {
    public PID = '';
    public Communiuty = '';
    public Demographics?: Demographics;
    public CivicAddress = '';
    public CivicAddresses = [];
    public ParcelAssessments = [];
    public ParcelHrmData = new ParcelHrmData({});
    public ChildParcels = null; // ?? pid array ??
    public BuildPermits = [];
    public WalkTimeGeoJson = '';
    public IsParent = false;
    public ParcelSizeFtSq = 0;

    constructor(
        parcelDataObject: any,
    ) {
        this.PID = parcelDataObject.pid;
        this.Communiuty = parcelDataObject.communiuty;
        if (parcelDataObject.demographics) {
            this.Demographics = new Demographics(parcelDataObject.demographics);
        }
        this.CivicAddress = parcelDataObject.civicAddress;
        if (parcelDataObject.civicAddresses && parcelDataObject.civicAddresses.length) {
            this.CivicAddresses = parcelDataObject.civicAddresses.map( (civic: any) => new CivicAddress(civic) );
        }
        if (parcelDataObject.parcelAssessments && parcelDataObject.parcelAssessments.length) {
            this.ParcelAssessments = parcelDataObject.parcelAssessments.map( (assessment: any) => new ParcelAssessment(assessment) );
        }
        this.ParcelHrmData = parcelDataObject.parcelHrmData ? new ParcelHrmData(parcelDataObject.parcelHrmData) : new ParcelHrmData({});
        this.ChildParcels = parcelDataObject.childParcels;
        this.BuildPermits = parcelDataObject.buildPermits.map( (permit: any) => new BuildingPermit(permit) );
        this.WalkTimeGeoJson = parcelDataObject.walkTimeGeoJson;
        this.IsParent = parcelDataObject.isParent;
        this.ParcelSizeFtSq = parcelDataObject.areaFtSq;
    }
}
